import * as signalR from '@microsoft/signalr'
import { store } from '../redux/state'
import { getConfigValue } from '../constants/config'

let connection = null

function getTransportName(conn) {
  try {
    const transport = conn.connection && conn.connection.transport
    if (!transport) return 'Unknown'
    const name = (transport.constructor && transport.constructor.name) || ''
    if (name.indexOf('WebSocket') !== -1) return 'WebSockets'
    if (name.indexOf('ServerSentEvents') !== -1) return 'ServerSentEvents (SSE)'
    if (name.indexOf('LongPolling') !== -1) return 'LongPolling'
    return name || 'Unknown'
  } catch (e) {
    return 'Unknown'
  }
}

const start = async () => {
  if (!connection) return
  try {
    await connection.start()
    const transport = getTransportName(connection)
    console.log(
      'FX SignalR Connected. Transport:', transport,
      '| State:', connection.state,
      '| ConnectionId:', connection.connectionId
    )
  } catch (err) {
    console.log('FX SignalR connection failed. State:', connection.state, 'Error:', err)
    setTimeout(() => start(), 5000)
  }
}

export const buildFxHubConnection = () => {
  if (connection) return connection

  let {
    oidc: { user }
  } = store.getState()
  if (!user || !user.access_token) return null

  const hubUrl = getConfigValue('fxNotificationHubUrl')
  if (!hubUrl) return null

  connection = new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, {
      accessTokenFactory: () => store.getState().oidc.user.access_token
    })
    .withAutomaticReconnect()
    .build()

  connection.onreconnecting(err => {
    console.log('FX SignalR reconnecting...', err)
  })

  connection.onreconnected(connectionId => {
    const transport = getTransportName(connection)
    console.log('FX SignalR reconnected. Transport:', transport, '| ConnectionId:', connectionId)
  })

  connection.onclose(err => {
    console.log('FX SignalR connection closed.', err)
    connection = null
  })

  start()

  return connection
}

export const closeFxHubConnection = () => {
  if (connection) {
    connection.stop()
    connection = null
  }
}

export const getFxConnectionInstance = () => connection
